import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "首页", to: "/" },
  { label: "热门专题", to: "/topics" },
  { label: "名场面", to: "/#comments" },
  { label: "常见问题", to: "/#faq" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-6 px-4 md:h-[72px] md:px-8">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
              瓜田观察
            </span>
            <span className="mt-0.5 hidden text-[10px] font-medium tracking-[0.2em] text-foreground-500 sm:block">
              只看评论区 不站队
            </span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center gap-1 lg:flex" aria-label="主导航">
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `cursor-pointer rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive && !item.to.includes("#")
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-200 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 lg:ml-0">
          <Link
            to="/topics"
            className="hidden cursor-pointer items-center gap-1.5 rounded-md border border-background-300 px-3.5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:flex"
          >
            <i className="ri-search-line text-base" />
            搜瓜
          </Link>
          <Link
            to="/#subscribe"
            className="hidden cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:flex"
          >
            <i className="ri-notification-3-line text-base" />
            订阅速报
          </Link>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-900 lg:hidden"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav className="mx-auto flex w-full flex-col px-4 py-3" aria-label="移动端导航">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="cursor-pointer rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-200"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/#subscribe"
              className="mt-2 cursor-pointer rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-semibold text-background-50"
            >
              订阅每日吃瓜速报
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}